"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCounter = exports.StyledTab = exports.StyledTabWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_utils_1 = require("../utils/styled-utils");
exports.StyledTabWrapper = styled_components_1.default.div `
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
  overflow: visible;
  background-color: ${(0, wl_ui_kit_1.getColor)('surface')};
  border-bottom: 1px solid ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
`;
exports.StyledTab = styled_components_1.default.a `
  ${wl_ui_kit_1.Subtitle1Styles};
  display: flex;
  flex-direction: row;
  place-items: center;
  gap: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  align-items: center;
  justify-content: flex-start;
  margin-bottom: -1px;
  padding: ${(0, wl_ui_kit_1.getSizeBy)(4)};
  color: ${({ isSelected }) => isSelected
    ? (0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')
    : (0, wl_ui_kit_1.getColorShade)('onSurface', 'mediumEmphasis')};
  border-bottom: ${({ isSelected, theme }) => `2px solid ${isSelected ? (0, wl_ui_kit_1.getColor)('primary')({ theme }) : 'transparent'}`};
  outline: none;
  cursor: pointer;

  &:hover {
    background-color: ${(0, wl_ui_kit_1.getColorShade)('primary', 'hover')};
  }

  &:active {
    background-color: ${(0, wl_ui_kit_1.getColorShade)('primary', 'pressed')};
  }

  &:focus-within {
    background-color: ${(0, wl_ui_kit_1.getColorShade)('primary', 'focused')};
  }
`;
exports.StyledCounter = styled_components_1.default.span `
  ${wl_ui_kit_1.Subtitle1Styles};
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(0, wl_ui_kit_1.getSizeBy)(3)};
  padding: 0 ${(0, wl_ui_kit_1.getSizeBy)()} 0 ${(0, wl_ui_kit_1.getSizeBy)()};
  color: ${({ $counterColor }) => (0, styled_utils_1.getCounterColor)($counterColor)};
  font-size: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  background-color: ${({ $counterBackgroundColor }) => (0, styled_utils_1.getCounterColor)($counterBackgroundColor)};
  border-radius: ${(0, wl_ui_kit_1.getSizeBy)(25)};
`;
